"use client";
import { useState } from "react";
import styles from "./OfflineExperience.module.scss";

const OfflineExperienceBlock = (data) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const OfflineData = data?.data;
  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <div className={styles.headingBlock}>
          <h2 id="oncampus-heading">{OfflineData?.Title}</h2>
          <p>{OfflineData?.Description}</p>
        </div>
        <div className={styles.cardsContainerMweb}>
          {OfflineData?.Imagelist?.map((item, ind) => {
            const isActive = activeIndex === ind;
            return (
                <div
                  key={ind}
                  className={`${styles.card} ${
                    isActive ? styles.activeCard : ""
                  }`}
                  onMouseEnter={() => setActiveIndex(ind)}
                >
                  <img
                    src={item?.Image?.data?.attributes?.url}
                    alt={item?.imageAlt}
                    className={styles.image}
                  />
                  <div className={styles.textBlock}>
                    <h3>{item?.TitleCk}</h3>
                    <p>{item?.DescriptionCk}</p>
                  </div>
                </div>
            );
          })}
        </div>
      

        <div className={styles.cardsContainerDweb}>
                <div className={styles.imageBlock}>
                  <img
                    src={
                      OfflineData?.Imagelist?.[activeIndex]?.Image?.data?.attributes?.url
                    }
                    alt={ OfflineData?.Imagelist?.[activeIndex]?.Image?.imageAlt}
                  />
                </div>
          <div className={styles.textList}>
            {OfflineData?.Imagelist.map((event, index) => (
                <div
                  key={index}
                  className={`${styles.textBlock} ${
                    index === activeIndex ? styles.active : ""
                  }`}
                  onMouseEnter={() => setActiveIndex(index)}
                >
                  <h3>{event?.TitleCk}</h3>
                  {index === activeIndex && <p>{event?.DescriptionCk}</p>}
                </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfflineExperienceBlock;
